import { render, staticRenderFns } from "./QuizResult.vue?vue&type=template&id=789949e0&scoped=true&"
import script from "./QuizResult.vue?vue&type=script&lang=js&"
export * from "./QuizResult.vue?vue&type=script&lang=js&"
import style0 from "./QuizResult.vue?vue&type=style&index=0&id=789949e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789949e0",
  null
  
)

export default component.exports